import React, { useEffect, useState, useMemo } from "react";
import { clsx } from "clsx";
import { toast } from "react-toastify";
import Marquee from "react-fast-marquee";

import { useAuth0 } from "@auth0/auth0-react";
import {
  Grid,
  Input,
  InputAdornment,
  IconButton,
  CircularProgress,
} from "@mui/material";

import "./styles.css";
import { Drawer } from "../Drawer";
import { FileHistory } from "../FileHistory";
import { ProgressCard } from "../ProgressCard";
import { getFileHistory, getFilesByPrefix } from "../../services/api.service";

export const Dashboard = () => {
  const [files, setFiles] = useState([]);
  const [prefix, setPrefix] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [searchedFiles, setSearchedFiles] = useState(null);
  const [processingFiles, setProcessingFiles] = useState([]);
  const [wantedModality, setWantedModality] = useState(null);
  const [continuationTokens, setContinuationTokens] = useState({});

  const [filesLoading, setFilesLoading] = useState(true);

  const equalsCheck = (a, b) =>
    a.length === b.length && a.every((v, i) => v === b[i]);

  const getProcessingFiles = async () => {
    const response = await getFileHistory(
      null,
      ["RAW", "QUEUED", "SUBMITTED", "PROCESSING", "RESULTS", "PROCESSED"],
      null
    );

    if (response.status == 200 || response.status == 201) {
      if (equalsCheck(response.data, processingFiles)) return;
      setProcessingFiles(response.data.data);
    } else {
      toast.error("Getting processing files failed!");
    }
  };

  const getAndSetFileHistory = async () => {
    setFilesLoading(true);

    const fetchTokenPage = (currentPage - 1).toString()

    const currentContinuationToken = continuationTokens[fetchTokenPage - 1] || null

    const response = await getFileHistory(
      wantedModality,
      ["RESULTS", "PROCESSED"],
      JSON.stringify(currentContinuationToken)
    );

    console.log(continuationTokens);
    if (response.status == 200 || response.status == 201) {
      setContinuationTokens((prevTokens) => ({...prevTokens, [fetchTokenPage]: response.data.continuation_token}));
      setFiles(response.data.data);
    } else {
      toast.error("Getting files failed!!");
    }

    setFilesLoading(false);
  };

  const getAndSetVideosByPrefix = async () => {
    const response = await getFilesByPrefix(prefix);

    if (response.status == 200 || response.status == 201) {
      setSearchedFiles(response.data.data);
    } else {
      toast.error("Getting files failed!");
    }
  };

  const setOrUnsetWantedModalities = (modality) => {
    if (modality == wantedModality) {
      setWantedModality(null);
    } else {
      setWantedModality(modality);
    }
  };

  useEffect(() => {
    if (searchedFiles !== null) return;
    getAndSetFileHistory();
  }, [wantedModality, currentPage, searchedFiles]);

  useEffect(() => {
    getProcessingFiles();

    const interval = setInterval(() => {
      getProcessingFiles();
    }, 120000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (prefix.length < 5) {
      setSearchedFiles(null);
      return;
    }

    getAndSetVideosByPrefix();
  }, [prefix]);

  return (
    <>
      <Drawer>
        <div style={{ margin: "1%", marginTop: "-2%" }}>
          <Marquee
            play={processingFiles.length > 3}
            pauseOnHover={true}
            style={{ maxWidth: "90vw" }}
          >
            {processingFiles.map((file) => (
              <ProgressCard
                key={file.filename}
                name={file.filename}
                status={file.status}
              />
            ))}
          </Marquee>
          <Grid container style={{ marginTop: "2%" }}>
            <Grid item md={6} xs={12}>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <p className="helperText">
                  Select the format to see detailed information:
                </p>
                <div className="modalitiesFilterContainer">
                  <div
                    className={clsx(
                      "filter",
                      wantedModality == "video" && "filter-selected",
                      filesLoading && "filter-disabled"
                    )}
                    onClick={() =>
                      !filesLoading && setOrUnsetWantedModalities("video")
                    }
                  >
                    Video
                  </div>
                  <div
                    className={clsx(
                      "filter",
                      wantedModality == "audio" && "filter-selected",
                      filesLoading && "filter-disabled"
                    )}
                    onClick={() =>
                      !filesLoading && setOrUnsetWantedModalities("audio")
                    }
                  >
                    Audio
                  </div>
                  <div
                    className={clsx(
                      "filter",
                      wantedModality == "image" && "filter-selected",
                      filesLoading && "filter-disabled"
                    )}
                    onClick={() =>
                      !filesLoading && setOrUnsetWantedModalities("image")
                    }
                  >
                    Image
                  </div>
                  <div
                    className={clsx(
                      "filter",
                      wantedModality == "text" && "filter-selected",
                      filesLoading && "filter-disabled"
                    )}
                    onClick={() =>
                      !filesLoading && setOrUnsetWantedModalities("text")
                    }
                  >
                    Text
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>

          <FileHistory
            filesLoading={filesLoading}
            files={searchedFiles ? searchedFiles : files}
            setFiles={setFiles}
            setSearchedFiles={setSearchedFiles}
            selectedModality={wantedModality}
            currentPage={currentPage}
            setPage={setCurrentPage}
            continuationToken={continuationTokens[currentPage - 1]}
          />
        </div>
      </Drawer>
    </>
  );
};
